module.exports = __webpack_public_path__ + "static/media/netbeans.0771e799.png";